// Pure helpers for the History list: grouping by day, a short "when" label, and title search.
const DAY = 24 * 60 * 60 * 1000;

const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

function daysAgo(iso, now) {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return null;
  return Math.round((startOfDay(now) - startOfDay(then)) / DAY);
}

// [{ label: "Today", items: [...] }, ...] newest first; empty groups are left out.
export function groupConversations(items, now = new Date()) {
  const buckets = { today: [], yesterday: [], week: [], earlier: [] };
  [...items]
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    .forEach((c) => {
      const d = daysAgo(c.updated_at, now);
      if (d === null || d >= 7) buckets.earlier.push(c);
      else if (d <= 0) buckets.today.push(c);
      else if (d === 1) buckets.yesterday.push(c);
      else buckets.week.push(c);
    });
  return [
    { label: "Today", items: buckets.today },
    { label: "Yesterday", items: buckets.yesterday },
    { label: "Earlier this week", items: buckets.week },
    { label: "Earlier", items: buckets.earlier },
  ].filter((g) => g.items.length > 0);
}

// "2:14 PM" today, "Yesterday", "Mon" within the week, then "Oct 3" (with the year if it is not this year).
export function formatWhen(iso, now = new Date()) {
  const then = new Date(iso);
  const d = daysAgo(iso, now);
  if (d === null) return "";
  if (d <= 0) return then.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  if (d === 1) return "Yesterday";
  if (d < 7) return then.toLocaleDateString("en-US", { weekday: "short" });
  const sameYear = then.getFullYear() === now.getFullYear();
  return then.toLocaleDateString("en-US", sameYear ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" });
}

export function filterConversations(items, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return items;
  return items.filter((c) => String(c.title || "").toLowerCase().includes(q));
}
